import React from "react";
import { css } from "emotion";
import { defaultStyle, symbolStyle } from "./style";

const Item = ({ symbol, children, marginMultiplier }) => {
	const defaultStyleItem = defaultStyle(marginMultiplier);

	return (
		<div
			className={css`
				${defaultStyleItem};
			`}
		>
			<div
				className={css`
					${symbolStyle};
				`}
			>
				{symbol}
			</div>
			<div>{children}</div>
		</div>
	);
};

Item.defaultProps = {
	symbol: "+",
	margin: false
};

export default Item;
